const ADMIN_BASE_URL = '/'

const LAUNCHER_URL = ADMIN_BASE_URL
const LOGIN_URL = `${ADMIN_BASE_URL}login`
const NOT_FOUND_URL = `${ADMIN_BASE_URL}not-found`

const ADMIN_DASHBOARD_URL = `${ADMIN_BASE_URL}admin-dashboard`
const UPDATE_PARTNER_DRIVER_URL = `${ADMIN_BASE_URL}update-partner-driver`
// The driver is its own route rather than an inline panel, so a driver can be deep-linked and
// Back returns to the search results the user left.
const UPDATE_PARTNER_DRIVER_DRIVER_URL = `${UPDATE_PARTNER_DRIVER_URL}/:partnerDriverId`
// The steps table is its own page so the driver page stays a summary of cards. A static trailing
// segment, so React Router ranks it above the bare `:partnerDriverId` route.
const UPDATE_PARTNER_DRIVER_STEPS_URL = `${UPDATE_PARTNER_DRIVER_DRIVER_URL}/steps`
const INTERNAL_DOCUMENT_REVIEW_URL = `${ADMIN_BASE_URL}internal-document-review`
// Review screens are their own routes rather than an overlay so a reviewer can deep-link a
// document to a colleague and so Back returns to the queue tab they left.
const INTERNAL_DOCUMENT_REVIEW_CONTRACTOR_URL = `${INTERNAL_DOCUMENT_REVIEW_URL}/contractor/:stepId`
const INTERNAL_DOCUMENT_REVIEW_MC_URL = `${INTERNAL_DOCUMENT_REVIEW_URL}/master-contractor/:collectedDataId`
const PAYMENTS_OPS_URL = `${ADMIN_BASE_URL}payments-ops`
const PAYMENTS_OPS_PAYMENTS_REVIEW_URL = `${PAYMENTS_OPS_URL}/payments-review`
const PAYMENTS_OPS_INCOMING_TRANSACTIONS_URL = `${PAYMENTS_OPS_URL}/incoming-transactions`
const PAYMENTS_OPS_OUTGOING_TRANSACTIONS_URL = `${PAYMENTS_OPS_URL}/outgoing-transactions`
const PAYMENTS_OPS_REFUNDS_URL = `${PAYMENTS_OPS_URL}/refunds`
const PAYMENTS_OPS_BANK_ONBOARDING_URL = `${PAYMENTS_OPS_URL}/bank-onboarding`
// A static segment, so React Router ranks it above any future `:param` sibling.
const PAYMENTS_OPS_NEW_BANK_ONBOARDING_URL = `${PAYMENTS_OPS_BANK_ONBOARDING_URL}/new`
const PAYMENTS_OPS_US_BANK_TRANSACTIONS_URL = `${PAYMENTS_OPS_URL}/us-bank-transactions`
const PAYMENTS_OPS_WALLETS_URL = `${PAYMENTS_OPS_URL}/wallets`
const PAYMENTS_OPS_FEES_WITHDRAW_REPORTS_URL = `${PAYMENTS_OPS_URL}/fees-withdraw-reports`
const PAYMENTS_OPS_RECONCILIATION_URL = `${PAYMENTS_OPS_URL}/reconciliation`
const PAYMENTS_OPS_KILLSWITCH_URL = `${PAYMENTS_OPS_URL}/killswitch`
const SCHEDULERS_MANAGEMENT_URL = `${ADMIN_BASE_URL}schedulers-management`
const SCHEDULERS_MANAGEMENT_ACTION_URL = `${SCHEDULERS_MANAGEMENT_URL}/:configId`
// The action's retry jobs and the reschedule form, split out of the detail page so that screen
// stays a two-column summary. A static trailing segment, so React Router ranks it above the
// `:configId` route regardless of declaration order.
const SCHEDULERS_MANAGEMENT_ACTION_RETRIES_URL = `${SCHEDULERS_MANAGEMENT_ACTION_URL}/retries`
const USERS_MANAGEMENT_URL = `${ADMIN_BASE_URL}users-management`
// Create mode of the role editor. A static segment, so React Router ranks it above `:roleId`.
const USERS_MANAGEMENT_NEW_ROLE_URL = `${USERS_MANAGEMENT_URL}/roles/new`
// The role editor is a route rather than a modal: ~100 permission checkboxes need the room, and
// a role can be deep-linked. Back returns to the Roles tab through the carried query string.
const USERS_MANAGEMENT_ROLE_URL = `${USERS_MANAGEMENT_URL}/roles/:roleId`

const REMOTE_CONFIG_URL = `${ADMIN_BASE_URL}remote-config`
// One page per app, so the rail is plain navigation and each list can be deep-linked.
const REMOTE_CONFIG_CLIENT_URL = `${REMOTE_CONFIG_URL}/client`
const REMOTE_CONFIG_DASHBOARD_URL = `${REMOTE_CONFIG_URL}/dashboard`

const ADMIN_DASHBOARD_CUSTOMERS_URL = `${ADMIN_DASHBOARD_URL}/customers`
const ADMIN_DASHBOARD_INSURANCE_PRODUCTS_URL = `${ADMIN_DASHBOARD_URL}/insurance-products`
const ADMIN_DASHBOARD_LMS_COURSES_URL = `${ADMIN_DASHBOARD_URL}/lms-courses`

const ADMIN_DASHBOARD_CUSTOMER_URL = `${ADMIN_DASHBOARD_CUSTOMERS_URL}/:customerId`
const ADMIN_DASHBOARD_CUSTOMER_SETTINGS_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/settings`
const ADMIN_DASHBOARD_CUSTOMER_BUSINESS_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/business`
const ADMIN_DASHBOARD_CUSTOMER_INVOICE_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/invoice`
const ADMIN_DASHBOARD_CUSTOMER_INVOICE_DETAILS_URL = `${ADMIN_DASHBOARD_CUSTOMER_INVOICE_URL}/:composedInvoiceId`
const ADMIN_DASHBOARD_CUSTOMER_INSURANCE_POLICY_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/insurance/:insurancePolicyPermanentId`
const ADMIN_DASHBOARD_CUSTOMER_AI_REVIEW_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/ai-review`

// New-template mode. A static segment, so React Router ranks it above `:templateId` and above the
// `${ADMIN_DASHBOARD_CUSTOMER_URL}/*` catch-all regardless of declaration order. `templateId` is
// absent on this route, which is what keeps the editor from issuing the single-template GET.
const FLOW_EDITOR_NEW_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/onboarding-templates/new`

const FLOW_EDITOR_URL = `${ADMIN_DASHBOARD_CUSTOMER_URL}/onboarding-templates/:templateId`

// Pre-ENG-472 flow editor URL. Kept as a redirect so existing bookmarks and pasted
// links keep working; see docs/superpowers/specs/2026-08-26-admin-navigation-skeleton-design.md
const LEGACY_FLOW_EDITOR_URL = `${ADMIN_BASE_URL}customers/:customerId/onboarding/:templateId`

// The pre-tab URL this screen shipped at. Kept as a redirect to the tab so existing links and
// bookmarks still resolve — see AppRoutes.
const AI_DOCUMENT_REVIEW_CONFIGS_URL = `${ADMIN_BASE_URL}customers/:customerId/ai-document-review-configs`

export const ADMIN_ROUTES = {
  LAUNCHER_URL,
  LOGIN_URL,
  NOT_FOUND_URL,

  ADMIN_DASHBOARD_URL,
  UPDATE_PARTNER_DRIVER_URL,
  UPDATE_PARTNER_DRIVER_DRIVER_URL,
  UPDATE_PARTNER_DRIVER_STEPS_URL,
  INTERNAL_DOCUMENT_REVIEW_URL,
  INTERNAL_DOCUMENT_REVIEW_CONTRACTOR_URL,
  INTERNAL_DOCUMENT_REVIEW_MC_URL,
  PAYMENTS_OPS_URL,
  PAYMENTS_OPS_PAYMENTS_REVIEW_URL,
  PAYMENTS_OPS_INCOMING_TRANSACTIONS_URL,
  PAYMENTS_OPS_OUTGOING_TRANSACTIONS_URL,
  PAYMENTS_OPS_REFUNDS_URL,
  PAYMENTS_OPS_BANK_ONBOARDING_URL,
  PAYMENTS_OPS_NEW_BANK_ONBOARDING_URL,
  PAYMENTS_OPS_US_BANK_TRANSACTIONS_URL,
  PAYMENTS_OPS_WALLETS_URL,
  PAYMENTS_OPS_FEES_WITHDRAW_REPORTS_URL,
  PAYMENTS_OPS_RECONCILIATION_URL,
  PAYMENTS_OPS_KILLSWITCH_URL,
  SCHEDULERS_MANAGEMENT_URL,
  SCHEDULERS_MANAGEMENT_ACTION_URL,
  SCHEDULERS_MANAGEMENT_ACTION_RETRIES_URL,
  USERS_MANAGEMENT_URL,
  USERS_MANAGEMENT_NEW_ROLE_URL,
  USERS_MANAGEMENT_ROLE_URL,
  REMOTE_CONFIG_URL,
  REMOTE_CONFIG_CLIENT_URL,
  REMOTE_CONFIG_DASHBOARD_URL,

  ADMIN_DASHBOARD_CUSTOMERS_URL,
  ADMIN_DASHBOARD_INSURANCE_PRODUCTS_URL,
  ADMIN_DASHBOARD_LMS_COURSES_URL,
  ADMIN_DASHBOARD_CUSTOMER_URL,
  ADMIN_DASHBOARD_CUSTOMER_SETTINGS_URL,
  ADMIN_DASHBOARD_CUSTOMER_BUSINESS_URL,
  ADMIN_DASHBOARD_CUSTOMER_INVOICE_URL,
  ADMIN_DASHBOARD_CUSTOMER_INVOICE_DETAILS_URL,
  ADMIN_DASHBOARD_CUSTOMER_INSURANCE_POLICY_URL,
  ADMIN_DASHBOARD_CUSTOMER_AI_REVIEW_URL,

  FLOW_EDITOR_NEW_URL,
  FLOW_EDITOR_URL,
  LEGACY_FLOW_EDITOR_URL,

  AI_DOCUMENT_REVIEW_CONFIGS_URL,
}

export const buildScheduledActionPath = (configId: string): string => {
  return `${ADMIN_ROUTES.SCHEDULERS_MANAGEMENT_URL}/${configId}`
}

export const buildScheduledActionRetriesPath = (configId: string): string => {
  return `${buildScheduledActionPath(configId)}/retries`
}

export const buildInternalRolePath = (roleId: string): string => {
  return `${ADMIN_ROUTES.USERS_MANAGEMENT_URL}/roles/${roleId}`
}

export const buildPartnerDriverPath = (partnerDriverId: string): string => {
  return `${ADMIN_ROUTES.UPDATE_PARTNER_DRIVER_URL}/${partnerDriverId}`
}

export const buildPartnerDriverStepsPath = (partnerDriverId: string): string => {
  return `${buildPartnerDriverPath(partnerDriverId)}/steps`
}

export const buildNewBankOnboardingPath = (fromOnboardingId?: string): string => {
  if (!fromOnboardingId) {
    return ADMIN_ROUTES.PAYMENTS_OPS_NEW_BANK_ONBOARDING_URL
  }

  return `${ADMIN_ROUTES.PAYMENTS_OPS_NEW_BANK_ONBOARDING_URL}?from=${encodeURIComponent(
    fromOnboardingId,
  )}`
}

export const buildRemoteConfigAppPath = (app: string): string => {
  return `${ADMIN_ROUTES.REMOTE_CONFIG_URL}/${app}`
}
